module.exports = __webpack_public_path__ + "static/img/icon-enter-item2.54213ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-enter-item2.png
// module id = kzvl
// module chunks = 21